import { FC } from 'react';
import ProCollapse, { CollapseProps } from './collapse';
import ProCollapsePanel, { CollapsePanelProps } from './panel';

export type ICollapseComponent = FC<CollapseProps> & {
  Panel: FC<CollapsePanelProps>;
};

const TransCollapse = ProCollapse as ICollapseComponent;
TransCollapse.Panel = ProCollapsePanel;

export default TransCollapse;
